import { IIconBase } from '..'

const documentTextErrorIcon = ({
  color = '#DC3545',
  height = 15,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/document-text'>
        <g id='document-text'>
          <path
            id='Vector'
            d='M12.25 4.58317V10.4165C12.25 12.1665 11.375 13.3332 9.33333 13.3332H4.66667C2.625 13.3332 1.75 12.1665 1.75 10.4165V4.58317C1.75 2.83317 2.625 1.6665 4.66667 1.6665H9.33333C11.375 1.6665 12.25 2.83317 12.25 4.58317Z'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M8.4585 3.125V4.29167C8.4585 4.93333 8.9835 5.45833 9.62516 5.45833H10.7918'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M4.6665 8.0835H6.99984'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M4.6665 10.4165H9.33317'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default documentTextErrorIcon
